import { useEffect, useState } from "react";
import { Location as TQSLocation } from "../../models/location";
import { useAppSelector } from "../../reducers/store";

export function LocationBanner(props: {
  selectedLocation: TQSLocation;
  allLocations: TQSLocation[];
  setSelectedLocation: (location: TQSLocation) => void;
}) {
  const [qualityAlertCount, setQualityAlertCount] = useState(0);
  const selectedSupplier = useAppSelector((state) => state.supplier.selectedSupplier);
  const selectedProducingFacilities = useAppSelector((state) => state.supplier.selectedProducingFacilities);

  useEffect(() => {
    processQualityAlerts();
  }, [props?.selectedLocation, props?.allLocations]);

  const processQualityAlerts = () => {
    setQualityAlertCount(
      props?.allLocations
        ?.filter(
          (l) =>
            !props?.selectedLocation?.id ||
            l.id === props?.selectedLocation?.id,
        )
        .reduce((prev, cur) => (prev += cur.qualityAlerts
          ?.filter(q => q.supplier === selectedSupplier?.id || selectedProducingFacilities.map(s => s.id).includes(q.supplier as number))
          ?.filter(q => q.status !== 'Closed')?.length ?? 0), 0) ??
        0,
    );
  };

  // setQualityCount(props.location.qualityAlerts?.filter(q => q.supplier === selectedSupplier?.id || selectedProducingFacilities.map(s => s.id).includes(q.supplier as number)).length ?? 0);

  function formatDate(dateString: string | undefined): string {
    if (!dateString) {
      return "";
    }

    // const date = new Date(dateString);
    const dateSplit = dateString.split("-");

    // if (isNaN(date.getTime())) {
    //   // If the date is invalid, return the original string
    //   return dateString;
    // }

    // const month = ("0" + (date.getMonth() + 1)).slice(-2);
    // const day = ("0" + date.getDate()).slice(-2);
    // const year = date.getFullYear();

    return `${dateSplit[1]}/${dateSplit[2]}/${dateSplit[0]}`;
  }
  return (
    <div className="flex h-[65px] w-[100%] flex-row items-center justify-between gap-x-[10px] border-b-[1px] border-[#E5E5E5] pb-[8px] text-[#212322]">
      <div className="flex flex-row items-center gap-x-[12px]">
        {!props?.selectedLocation?.oemPicture?.s3Code && (
          <div className="flex h-[48px] w-[48px] items-center justify-center rounded-[50%] bg-[black]">
            <img
              className="h-[30px] w-[30px]"
              src={
                "https://s3.amazonaws.com/com.teamqualityservices.qnet/images/Logo+Q+Only.png"
              }
            />
          </div>
        )}
        {props?.selectedLocation?.oemPicture?.s3Code && (
          <img
            className="h-[54px] w-[54px]"
            src={props?.selectedLocation?.oemPicture?.s3Code}
          />
        )}

        <div className="flex flex-col">
          <div>
            <span className="text-[20px] font-semibold text-[#212322]">
              {props?.selectedLocation?.name ?? "All Service Locations"}
            </span>
          </div>
          <div>
            <span className="text-[14px] font-semibold text-[grey]">
              {props?.selectedLocation?.id
                ? `${props?.selectedLocation?.agreement?.agreementId} 
     ${props?.selectedLocation?.agreement?.priceType ? ` • ${props?.selectedLocation?.agreement?.priceType}` : ""} 
     ${props?.selectedLocation?.agreement?.contractHours && props?.selectedLocation?.agreement?.contractHours > 0 ? ` • Contracted Hours per ${props?.selectedLocation?.agreement?.priceType == 'Monthly Pricing'?'Month':'Week'}: ${props?.selectedLocation?.agreement?.priceType == 'Monthly Pricing'?props?.selectedLocation?.agreement?.monthlyUnits:props?.selectedLocation?.agreement?.contractHours} ` : ""} 
     ${props?.selectedLocation?.agreement?.level !== null ? ` • Level: ${props?.selectedLocation?.agreement?.level}` : ""} 
   `
                : "Data across each service location"}
            </span>
          </div>
        </div>
      </div>

      <div className="flex w-[180px] flex-col text-right">
        <div
          className={`rounded-[4px] p-[4px] text-[14px] ${qualityAlertCount > 0 ? "bg-tqsLightRed" : "bg-[#21232230]"} flex items-center justify-center`}
        >
          <span
            className={`${qualityAlertCount > 0 ? "text-[14px] text-tqsRed" : "text-[14px] text-[#212322]"}`}
          >
            {qualityAlertCount} OPEN ISSUES
          </span>
        </div>
        <div className="text-[14px] font-semibold text-[grey]">
          {!props?.selectedLocation?.id && (
            <span>
              across {props.allLocations.length ?? "-"} service locations
            </span>
          )}
          {props?.selectedLocation?.id && (
            <span>
              Coverage Started:{" "}
              {formatDate(props?.selectedLocation?.agreement?.startTime)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
